import { DictationProcessingContent } from '@/features/dictation/dictation-shared/components/dictation-processing-content';
import { useDictationStore } from '@/features/dictation/dictationBubble/store/useDictationStore';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { cn } from '@/lib/cn';
import {
  bubbleExitAnimation,
  DICTATION_BUBBLE_Z_INDEX_CLASS,
  DictationBubbleShell,
} from '@heidi/dictate';

export const DictationProcessing = () => {
  const cancel = useDictationStore((s) => s.cancel);
  const isMobile = useIsMobile();

  return (
    <DictationBubbleShell
      animation={bubbleExitAnimation}
      className={cn(
        'fixed inset-x-0 mx-auto flex w-fit flex-col items-center gap-2',
        DICTATION_BUBBLE_Z_INDEX_CLASS,
        isMobile ? 'bottom-32' : 'bottom-6'
      )}
    >
      <DictationProcessingContent onCancel={cancel} />
    </DictationBubbleShell>
  );
};
